export default "__VITE_ASSET__UEi5bqNK__"